import ExpertB2BDataService from "../../../services/ExpertB2B";
import { SingleExpertB2BRow } from "../../../components/List/SingleExpertB2BRow";
import { Select, useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const ExpertB2BList = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("logged_in_user_token");
  const [list, setList] = useState<any>();
  const [search, setSearch] = useState("");
  const [expertise, setExpertise] = useState("");
  const [expert, setExpert] = useState("");
  const toast = useToast();

  const [drawer, setDrawer] = useState<any>("");
  const { isOpen, onOpen, onClose } = useDisclosure();

  const isNgodelete = (isdelete: true) => {
    fetchData();
  };

  const fetchData = async () => {
    ExpertB2BDataService.getAllB2BExperts(token, search, expertise, expert)
      .then((res: any) => {
        setList(res.data.data);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2 ">Experts - B2B Expert</div>
        <div className="p-4">
          <div className="d-flex justify-content-between">
            <div className="input-group col-md-4">
              <button
                type="button"
                className="btn action-btn custom-btn"
                onClick={() => navigate("add")}
              >
                Create Expert
              </button>
            </div>
            <div className="d-flex justify-content-end align-items-center">
              <div className="input-group col-md-5">
                <input
                  value={expert}
                  onChange={(e) => setExpert(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                  type="text"
                  className="form-control search-bar"
                  placeholder="Search by expert name"
                  id="expert"
                  name="expert"
                />
              </div>
              <div className="input-group col-md-5">
                <input
                  value={expertise}
                  onChange={(e) => setExpertise(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                  type="text"
                  className="form-control search-bar"
                  placeholder="Search by expertise"
                  id="expertise"
                  name="expertise"
                />
              </div>
              <div className="input-group col-md-5">
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                  type="text"
                  className="form-control search-bar"
                  placeholder="Search by city"
                  id="search"
                  name="search"
                />
              </div>
            </div>
          </div>
          <div className="nested p-lg-0">
            <div className="d-flex justify-content-end input-group-append">
              <button
                type="button"
                className="input-group-text btn action-btn m-3"
                onClick={() => fetchData()}
              >
                Search
              </button>
            </div>
          </div>

          <div className="main-section" style={{ overflowX: "auto" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Edit</th>
                  <th>View</th>
                  <th>Name</th>
                  <th>Expertise</th>
                  {/* <th>Email</th> */}
                  <th>Phone number</th>
                  {/* <th>Address</th> */}
                  <th>City</th>
                  <th>Worked With Manoshala</th>
                  <th>Created By</th>
                  <th>Work Experience</th>
                  <th>Prior Manoshala Clients</th>
                  {/* <th>State</th> */}
                  <th>Rating</th>
                  <th>Price Scale</th>
                  {/* <th>Country</th> */}
                  {/* <th>Pincode</th> */}
                  <th>Notes</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleExpertB2BRow
                      key={el.id}
                      props={el}
                      id={el._id}
                      func={isNgodelete}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
